import { AccountInfo, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../environments/environment';
import { filter, Subject, takeUntil } from 'rxjs';
import { IdleTimeoutService, LoginService } from '@web/csl-lib-services';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, OnDestroy {
  private msalGuardConfig = inject<MsalGuardConfiguration>(MSAL_GUARD_CONFIG);
  private msalService = inject(MsalService);
  private msalBroadcastService = inject(MsalBroadcastService);
  private loginService = inject(LoginService);
  private idleTimeoutService = inject(IdleTimeoutService);


  /* Store */


  /* Services */


  /* Member Vars */

  title = 'csl-admin-portal';
  private readonly _destroying$ = new Subject<void>();

  ngOnInit(): void {
    // this.msalService.handleRedirectObservable().subscribe();
    // this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal

    this.setLoginDisplay();

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.LOGIN_SUCCESS ||
            msg.eventType === EventType.LOGOUT_SUCCESS
        )
      )
      .subscribe((result: EventMessage) => {
        if (this.msalService.instance.getAllAccounts().length === 0) {
          window.location.pathname = '/';
        } else {
          this.setLoginDisplay();
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });

    this.idleTimeoutService.startIdleDetection(environment.production ? 30 : 10);

    // Subscribe to the LOGIN_SUCCESS event; when the user has logged in, get the clinic
    // from the claims and set it in the store. This will trigger other initialization events.
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      )
      .subscribe((result: EventMessage) => {
        const account = result.payload as AccountInfo;

        // If the user is not an admin, log out and redirect
        if (
          !(
            account.idTokenClaims &&
            account.idTokenClaims['extension_IsSurvivorLinkAdmin'] &&
            account.idTokenClaims['extension_IsSurvivorLinkAdmin'] === true
          )
        ) {
          this.msalService.logoutRedirect({
            account,
            idTokenHint: account.idToken,
            postLogoutRedirectUri: environment.logoutRedirectUrl,
          });
        }

      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }


  /* Event Handlers */


  /* Instance Methods */

  setLoginDisplay() {
    // Use a signal so other components and inject loginService can subscribe to loginDisplay changes
    this.loginService.loginDisplaySig.set(this.msalService.instance.getAllAccounts().length > 0);
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.msalService.instance.getActiveAccount();

    if (
      !activeAccount &&
      this.msalService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  }



}
